import { Pipe, PipeTransform } from '@angular/core';
import {ShoppingModel} from '../../../models/shopping.model';

@Pipe({
  name: 'shoppingfilterpipe',
  pure: false
})

export class ShoppingFilterPipe implements PipeTransform {
  transform(items: any[], filter: ShoppingModel): any {
    if (!items || !filter || !filter.name || filter.name.length < 0) {
      return items;
    }

    return items.filter(item => item.name.toLowerCase().indexOf(filter.name.toLowerCase()) !== -1);
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/pipe/shopping.filter.pipe.ts